export interface MovieReview {
  id: string;
  movieId: string;
  title: string;
  excerpt: string;
  content: string[];
  author: string;
  date: string;
  likes: number;
  featured: boolean;
}

export const reviews: MovieReview[] = [
  {
    id: "rv-yuzhong-01",
    movieId: "yu-zhong-lai-xin",
    title: "《雨中来信》：最深的告白，是不打扰的等待",
    excerpt:
      "它没有把爱情讲得轰轰烈烈，而是把七年的沉默，藏进每一个下雨的黄昏。看完之后，你会想把那条湿漉漉的巷子再走一遍。",
    content: [
      "《雨中来信》最动人的地方，在于它相信「慢」。整部电影几乎没有一个高声的瞬间，所有的情绪都落在雨声、翻书声和两个人短暂的沉默里。",
      "苏未晚与陈屿的关系，是由一封封信慢慢垒起来的。导演显然不喜欢把话说满，她更愿意让镜头停留在伞下的空隙、书页的批注，让观众自己去补全那些没说出口的话。",
      "影片的真正主题，其实是「等待」——等一个回信、等雨停、等一个人终于愿意开口。它提醒我们，有些爱并不需要被立刻回应，只要还在等，就已经足够动人。",
    ],
    author: "拾光笔记",
    date: "2023-11-08",
    likes: 328,
    featured: true,
  },
  {
    id: "rv-bali-01",
    movieId: "bali-de-zuihou-yizhiwu",
    title: "《巴黎的最后一支舞》：用九分钟，跳完一生",
    excerpt:
      "那支长达九分钟的华尔兹，是所有爱情片里最克制也最汹涌的告别。它没有一句台词，却比任何誓言都完整。",
    content: [
      "如果只能记住《巴黎的最后一支舞》的一个镜头，那一定是结尾的华尔兹。空荡的舞厅里，两个年龄相差悬殊的人缓缓起舞，灯光把他们的影子拉得很长。",
      "导演没有安排任何狗血的转折，而是让告别自然到来——舞厅终将关闭，人也终将各奔东西。恰恰是这种无可挽回，让那支舞有了重量。",
      "Camille 与 Julien 之间的关系很难定义，它介于爱情、知己与救赎之间，也正是这种模糊，让它比普通的浪漫故事更接近生活本身。",
    ],
    author: "光影拾遗",
    date: "2023-09-21",
    likes: 512,
    featured: true,
  },
  {
    id: "rv-mingyue-01",
    movieId: "ming-yue-zhao-gui-tu",
    title: "《明月照归途》：东方美学里的十年之约",
    excerpt:
      "把「等」字拍成一轮明月，是这部电影最聪明的地方。古装外壳下，讲的其实是我们每个人都懂的执念。",
    content: [
      "《明月照归途》把「约定」这个古老的主题拍出了新的诗意。明月不只是一个意象，它是时间的刻度，也是女主执念的化身。",
      "影片的服化道与夜景质感都相当考究，但真正留住人的，是沈梨一次次踏上归途时那份坚定。她不是不知道可能等不到，只是不愿放弃。",
      "在快节奏的今天，一部肯花两个小时讲「等待」的古装爱情片，本身就是一种难得的温柔。",
    ],
    author: "青衫客",
    date: "2023-08-15",
    likes: 441,
    featured: true,
  },
  {
    id: "rv-yinhe-01",
    movieId: "yinhe-jintou-de-ni",
    title: "《银河尽头的你》：我把告白，喊给了整个宇宙",
    excerpt:
      "科幻只是它的壳，内核是一句被无限拉长的「我喜欢你」。当信号跨越光年抵达，等待本身就成了答案。",
    content: [
      "很少有国产爱情片敢把科幻做得这么「真」。监听站的底噪、信号的载波、光年的时间差，这些细节让设定足够可信，也让人物的孤独有了物理上的重量。",
      "沈栖最终选择回应信号的那一幕，是全片的高光。她知道对方可能早已不在，却依然把话说出口——因为爱从来不是交换，而是一种自我的确认。",
      "结尾留白的处理非常高级，它没有给你一个确定的团聚，却给了你一个确定的相信。",
    ],
    author: "夜航星",
    date: "2024-03-02",
    likes: 620,
    featured: true,
  },
  {
    id: "rv-changye-01",
    movieId: "chang-ye",
    title: "《长夜将尽》：写给深夜的一封温柔情书",
    excerpt:
      "车厢是最小的舞台，也是最深的容器。两个陌生人把各自的伤口放进这段夜路里，然后各自痊愈了一点点。",
    content: [
      "这部电影几乎没有离开过车。狭小的空间反而放大了情绪，路灯一盏盏掠过车窗，像一段段被想起又被遗忘的往事。",
      "它讲的不是热烈的爱情，而是两个疲惫的人在深夜里互相取暖。那种陪伴，比告白更接近成年人的爱情。",
      "当乘客不再出现，你才意识到，原来有些人只是路过，却成了你整条夜路上唯一的方向。",
    ],
    author: "凌晨三点",
    date: "2023-06-30",
    likes: 287,
    featured: false,
  },
  {
    id: "rv-haibian-01",
    movieId: "hai-na-bian",
    title: "《海那边》：一整年最安静的眼泪",
    excerpt:
      "它把离别拍成了海风，看不见，却一直吹在你脸上。结局那个长镜头，足够让人沉默很久。",
    content: [
      "《海那边》放弃了所有戏剧化的冲突，转而相信「日常」的力量。补习、防波堤、末班车，这些琐碎构成了整个夏天。",
      "正因为没有承诺未来，两人相处的每一刻才显得珍贵。影片真正要说的，是有些相遇注定短暂，却不代表它不真实。",
      "结尾森川遥独自站在海边的镜头，没有任何配乐，只有海浪声。那种安静的痛，比嚎啕大哭更有穿透力。",
    ],
    author: "海风信使",
    date: "2023-05-18",
    likes: 356,
    featured: false,
  },
  {
    id: "rv-chengnan-01",
    movieId: "cheng-nan-hua-kai",
    title: "《城南花开》：最好的暗恋，是没说出口也闪着光",
    excerpt:
      "它几乎完美复刻了「同桌」这个词的全部含义——一本漫画、一副耳机、一整个夏天的欲言又止。",
    content: [
      "青春片的胜负手在细节，而《城南花开》把细节做到了极致。撕开的笔记本、共用的一支笔、被偷偷抄下的答案，每一处都能勾起回忆。",
      "顾清让的沉默不是冷淡，而是小心翼翼的保护。沈知夏的主动也不是冒失，而是她比谁都想让这个男孩被世界温柔对待。",
      "它没有强行给一个圆满结局，而是让那份暗恋停在最美好的位置——这反而更让人怀念。",
    ],
    author: "同桌的夏天",
    date: "2023-07-12",
    likes: 398,
    featured: false,
  },
  {
    id: "rv-manhadun-01",
    movieId: "manhadun-de-lan",
    title: "《曼哈顿的蓝》：都市爱情的正确打开方式",
    excerpt:
      "一场乌龙同住，把两个成年人逼进了最真实的相处。笑点密集，却不耽误它在该温柔的时候毫不含糊。",
    content: [
      "浪漫喜剧最怕的是用力过猛，而《曼哈顿的蓝》的分寸拿捏得刚好。所有笑点都源自人物性格，而非刻意的巧合堆砌。",
      "Emma 与 David 的化学反应是全片核心。他们从互相嫌弃到习惯彼此的存在，这个过程真实得让人会心一笑。",
      "它证明了浪漫喜剧不需要轰轰烈烈——有时候，爱情只是你终于愿意为一个人多做一道不辣的菜。",
    ],
    author: "都市观察员",
    date: "2023-04-25",
    likes: 201,
    featured: false,
  },
  {
    id: "rv-shiguang-01",
    movieId: "shiguang-lvren",
    title: "《时光旅人》：用最慢的方式，谈一场最远的恋爱",
    excerpt:
      "当照片成为时间唯一的证据，等待就被赋予了神圣感。它安静、诗意，像一首要读很多遍的诗。",
    content: [
      "胶片、冲印、信件的质感，让整部电影自带一层温柔的滤镜。导演显然迷恋「慢」，也相信观众愿意跟着慢下来。",
      "Eleanor 与陌生男子之间从未真正同框，却比很多同床共枕的爱情更亲密。影片探讨的是：如果注定无法同步，你还愿意爱吗？",
      "那帧定格照片的结尾处理堪称神来之笔，它没有解释时间的逻辑，而是把答案交还给了观众的心。",
    ],
    author: "胶片时代",
    date: "2023-10-09",
    likes: 274,
    featured: false,
  },
  {
    id: "rv-kafei-01",
    movieId: "kafei-yu-yu",
    title: "《咖啡与雨》：一间咖啡馆，装得下整个台北的温柔",
    excerpt:
      "没有大起大落，只有手冲的水声和雨点落在铁皮上的声音。看完只想找一家这样的小店，坐一整个下午。",
    content: [
      "作为一部小清新电影，《咖啡与雨》的野心并不大，它只想讲一个温暖的相遇。而恰恰是这种不贪心，让它格外动人。",
      "程以宁为雨天留一个位置的习惯，本身就是一种浪漫的姿态——她在等待某个不确定的人，也在温柔地对待这个世界。",
      "影片结尾没有煽情的告白，只有一杯续满的咖啡。那种克制的甜，比任何情话都更让人上瘾。",
    ],
    author: "午后时光",
    date: "2023-03-14",
    likes: 233,
    featured: false,
  },
  {
    id: "rv-qiuri-01",
    movieId: "qiuri-siyu",
    title: "《秋日私语》：爱到最后，是记得你爱吃什么",
    excerpt:
      "它把陪伴拍成了庭院里一株慢慢变红的枫树，不喧哗，却一年比一年深。看完想给家里的长辈打个电话。",
    content: [
      "《秋日私语》是那种越品越有味道的电影。它没有戏剧性的爱情，而是把镜头对准了时间之后的那部分——记得、习惯与守候。",
      "田中美咲写给亡夫的信，从未寄出，却在朗读里获得了生命。爱情在她的庭院里，变成了另一种形式的继续。",
      "影片最美的，是它不害怕衰老与失去。它温柔地告诉我们，爱过的人不会真的离开，他们活在你记得的每一个细节里。",
    ],
    author: "四季拾光",
    date: "2023-02-08",
    likes: 189,
    featured: false,
  },
];